import { supabase } from "@/integrations/supabase/client";

export const LISTING_IMAGES_BUCKET = "listing-images";

const slugify = (value: string) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "image";

const getFileExtension = (file: File) => {
  const nameExtension = file.name.split(".").pop()?.toLowerCase();
  if (nameExtension && /^[a-z0-9]+$/.test(nameExtension)) return nameExtension;

  const mimeExtension = file.type.split("/")[1]?.toLowerCase();
  return mimeExtension === "jpeg" ? "jpg" : mimeExtension || "jpg";
};

export const uploadListingImage = async (file: File, folder: string) => {
  const baseName = slugify(file.name.replace(/\.[^/.]+$/, ""));
  const extension = getFileExtension(file);
  const filePath = `${folder}/${Date.now()}-${crypto.randomUUID()}-${baseName}.${extension}`;

  const { error } = await supabase.storage.from(LISTING_IMAGES_BUCKET).upload(filePath, file, {
    upsert: false,
    contentType: file.type || undefined,
  });

  if (error) throw error;

  return supabase.storage.from(LISTING_IMAGES_BUCKET).getPublicUrl(filePath).data.publicUrl;
};